
import {styled} from '@mui/material'
import { TopDisplay } from '../../../../ui-components';
import {ReactComponent as BoxedWorld } from '../../../../svg/world_email.svg';
import {MdOutlineChevronRight as RightArrow} from "react-icons/md";
import EmailTemplateModal from '../Modal/settingsCustomModal'
import CreateEmailTemplateModal from '../Modal/settingsCustomModal';
import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import Input from "../../../../customs/FormInput";
import Select from "../../../../customs/SelectInput";
import CustomButton from "../../../../customs/Button";
import EmailTemplateCreate from './CreateEmalTemplate';
import EmailTemplateDelete from './DeleteEmailTemplate';
import EmailTemplateView from './VieiwEmailTemplate';
import {useState} from 'react'

const emailTemplateData = [
  {
    title: 'Training Induction',
    message: 'Congratulations!!!  After careful evaluation of your application process. We are pleased to inform you that you are eligible to move the next application process. You are invited...',
    icon: <BoxedWorld/>
  },
  {
    title: 'Training Induction',
    message: 'Congratulations!!!  After careful evaluation of your application process. We are pleased to inform you that you are eligible to move the next application process. You are invited...',
    icon: <BoxedWorld/>
  },
  {
    title: 'Training Induction',
    message: 'Congratulations!!!  After careful evaluation of your application process. We are pleased to inform you that you are eligible to move the next application process. You are invited...',
    icon: <BoxedWorld/>
  },
  {
    title: 'Training Induction',
    message: 'Congratulations!!!  After careful evaluation of your application process. We are pleased to inform you that you are eligible to move the next application process. You are invited...',
    icon: <BoxedWorld/>
  },
]

const Button = (props:any)=>{
  return (<button {...props}>{props.children}</button>)
}






const CreateBtn = ({...props})=> <Button {...props} 
style={{ backgroundColor:"#11643C",color:"#fff",border:"none", cursor: 'pointer',outline:"none",padding:"15px 20px", borderRadius:"5px",}}>
  Create Email Templates
</Button>;

export default function EmailTemplate(){

  const [openViewTemplateEmail ,setOpenViewTemplateEmail,] = useState(false);
  const [openCreateTemplateEmail, setOpenCreateTemplateEmail] = useState(false);
  const [openDeleteTemplateEmail, setOpenDeleteTemplateEmail] = useState(false);

  const handleOpenUpdateModal = () => {
    setOpenViewTemplateEmail(false);
    setOpenCreateTemplateEmail(true);
  }

  const handleOpenCreateModal = () => {
    setOpenCreateTemplateEmail(true)
  }

  const handleOpenDeleteModal = () => {
    setOpenViewTemplateEmail(false);
    setOpenDeleteTemplateEmail(true);
  }

  const handleOpenViewModal = () => {
    setOpenViewTemplateEmail(true);
  }

  const handleCancelViewTemplateEmail = () => {
    setOpenViewTemplateEmail(false);
  }
  
  return (
    <Container>
      <TopDisplay title="Email Template" subTitle="Settings" Btn = {<CustomButton onClick={handleOpenCreateModal} text={'Email Template'}/>} />
      <InnerContainer>
      {emailTemplateData && emailTemplateData.length > 0 ? 
          emailTemplateData.map((eData:any, index:number):any => 
            <TemplateWrapper onClick={handleOpenViewModal} key={index}>
              <div className='textIconWrapper'>
                <div>
                  {eData.icon} <span>{eData.title}</span>
                </div>
                <p style={{whiteSpace: 'nowrap'}}>{eData.message}</p>
              </div>
              <div  className={'arrowWrapper'}>
                <RightArrow/>
              </div>
            </TemplateWrapper>
          ):''}
            <EmailTemplateModal 
              header='Email Template' 
              open={openViewTemplateEmail}
              maxWidth= {'1330px'}
              card = {
                <>
                  <CardItems onClick={handleOpenUpdateModal} >Update</CardItems>
                  <CardItems onClick={handleOpenDeleteModal} >Delete</CardItems>
                </>
              }
              content = {<EmailTemplateView/>} 
              cancel={handleCancelViewTemplateEmail}/>

             <CreateEmailTemplateModal
              header='Email Template'
              open={openCreateTemplateEmail}
              maxWidth= {'920px'}
              showrightIcon= {false}
              cancel={setOpenCreateTemplateEmail}
              content = {<EmailTemplateCreate cancel={setOpenCreateTemplateEmail}/>} 
             /> 

            <CreateEmailTemplateModal
              header='Email Template'
              open={openDeleteTemplateEmail}
              maxWidth= {'653px'}
              showrightIcon= {false}
              cancel={setOpenDeleteTemplateEmail}
              content = {<EmailTemplateDelete cancel = {setOpenDeleteTemplateEmail}/>} 
             /> 
      </InnerContainer>
    </Container>
  )
}


const Container= styled('div')`
    padding: 0 20px 20px;
    width:100%;
`

const CardItems = styled(`div`)`
  height: 41px;
  background: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-inline-start: 23px;

  &:hover {
    background: #F1F1F1;
  }

`

export const InnerContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap:10px;
    margin-top:20px;
    width: 100%;
    margin-block-start: 41px;
`

const TemplateWrapper = styled('div')`
  border: 1px solid #E1E1E1;
  border-radius: 5px;
  display: grid;
  grid-template-columns: minmax(0px, auto ) 30px ;
  width: 100%;
  padding-inline: 16px;
  padding-block: 10px;
  cursor: pointer;

  & .arrowWrapper{
    display: flex;
    align-items: center;
    justify-content: center;

  }

  & > div > div> span {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  & > .textIconWrapper > div{
    display: flex;
      & span{
        margin: 0px 10px 10px 10px;
      }
  }

  & > .textIconWrapper > p{
    overflow: hidden; 
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #5F6063;
   }
`
